import React from 'react';
import { connect } from "react-redux";
import { Stack, Text } from '@chakra-ui/react';
import { setUserView } from '../../store/user/actions';
import { ReduxState } from '../../store/state';
import { UserOrdersDetails, UserTransactionsDetails } from '../../store/user/types';
import { MdCurrencyExchange, MdShoppingCart, MdTrendingUp } from 'react-icons/md';

interface ViewUserViewSelectorProps {
  setUserView: (view: string) => void;
  userView: string;
  userLocations: any[];
  userOrdersDetails: UserOrdersDetails;
  userTransactionsDetails: UserTransactionsDetails;
}

const ViewUserViewSelectors: React.FC<ViewUserViewSelectorProps> = ({ 
  userView, setUserView, 
  userLocations, userOrdersDetails, userTransactionsDetails }) => {
  return (
    <Stack direction="row" justify="center" spacing={6}>
      <ViewSelectorButton
        label="Orders"
        view="orders"
        userView={userView}
        icon={<MdShoppingCart />}
        count={userOrdersDetails.totalItems ? userOrdersDetails.totalItems : 0}
        setUserView={setUserView}
      />
      <ViewSelectorButton
        label="Transactions"
        view="transactions"
        userView={userView}
        icon={<MdCurrencyExchange />}
        count={userTransactionsDetails.totalItems ? userTransactionsDetails.totalItems : 0}
        setUserView={setUserView}
      />
    </Stack>
  );
}

interface ViewSelectorButtonProps {
  label: string;
  view: string;
  userView: string;
  count: number | string;
  icon?: React.ReactNode;
  setUserView: (view: string) => void;
}
const ViewSelectorButton: React.FC<ViewSelectorButtonProps> = ({ 
  label, view, userView, count, icon, setUserView }) => {
  return (
    <Stack 
      spacing={0} 
      align={'center'} 
      _hover={{
        outline: '2px dotted #F7941D'
      }}
      style={view === userView ? { outline: '2px solid #F7941D'} : {}}
      p="2"
      mx="2"
      borderRadius="lg"
      role="group"
      cursor="pointer"
      onClick={() => {setUserView(view)}}
    >
      { icon ? 
      icon :
      <Text fontWeight={600}>{count}</Text>
      }
      <Text fontSize={'sm'} color={'gray.500'}>
        {label}
      </Text>
    </Stack>
  );
}

const mapStateToProps = (state: ReduxState) => {
  const { 
    userView, 
    userLocations, 
    userOrdersDetails,
    userTransactionsDetails, 
  } = state.user;
  return {     
    userView, 
    userLocations, 
    userOrdersDetails,
    userTransactionsDetails
  };
};

export default connect(mapStateToProps, {
setUserView,
})(ViewUserViewSelectors);
